import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
	
	routes: [{
		path: '/',
		name: 'login',
		meta: {
			title: "积分兑换",
			keepAlive: false
		},
		component: resolve => require(['../pages/Login.vue'], resolve)
	},
	{
		path: '/home',
		name: 'home',
		meta: {
			title: "积分兑换",
			keepAlive: false
		},
		component: resolve => require(['../pages/Home.vue'], resolve)
	},
	{
		path: '/empty',
		name: 'empty',
		meta: {
			title: "积分兑换",
			keepAlive: false
		},
		component: resolve => require(['../pages/Empty.vue'], resolve)
	}]
})
